var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIsleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11_2127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C18.6274 0 24 5.37258 24 12H0C0 5.37258 5.37258 0 12 0Z",
    fill: "#F1564C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.5C16.6944 3.5 20.5 7.30558 20.5 12H3.5C3.5 7.30558 7.30558 3.5 12 3.5Z",
    fill: "#FC8B46"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7.5C14.4853 7.5 16.5 9.51472 16.5 12H7.5C7.5 9.51472 9.51472 7.5 12 7.5Z",
    fill: "#FDBB53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.970467 13.5H10.5449C10.9333 13.5 11.248 13.8163 11.248 14.2065C11.248 14.3616 11.1972 14.5124 11.1035 14.6357L6.11903 21.1853C5.85137 21.537 5.35063 21.6041 5.00061 21.3351C4.94452 21.292 4.89438 21.2416 4.85149 21.1853L0.198058 15.0706C-0.128158 14.6419 -0.0467891 14.0287 0.379801 13.7009C0.549398 13.5706 0.756965 13.5 0.970467 13.5Z",
    fill: "#2A3638"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4531 13.5H23.0276C23.5647 13.5 24 13.9374 24 14.4771C24 14.6916 23.9297 14.9002 23.8 15.0706L19.1466 21.1853C18.8789 21.537 18.3782 21.6041 18.0282 21.3351C17.9721 21.292 17.9219 21.2416 17.8791 21.1853L12.8946 14.6357C12.6587 14.3257 12.7176 13.8823 13.026 13.6453C13.1487 13.5511 13.2988 13.5 13.4531 13.5Z",
    fill: "#2A3638"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 13.5H20.5L12.6726 23.6684C12.3856 24.0413 11.8517 24.11 11.4803 23.8219C11.423 23.7775 11.3716 23.7259 11.3274 23.6684L3.5 13.5Z",
    fill: "#5F6257"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 13.5H16L12.2784 18.3627C12.1613 18.5158 11.9416 18.5453 11.7879 18.4287C11.7629 18.4098 11.7406 18.3876 11.7216 18.3627L8 13.5Z",
    fill: "#919078"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11_2127"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsleIcon);
export default __webpack_public_path__ + "static/media/isle_icon.73712e36fbd097f7efca87e7966c066a.svg";
export { ForwardRef as ReactComponent };